import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './CategoryPage.css';



// ProductCat
import go from '../../img/categories/Gardening.png';
import baby from '../../img/under/BABY.png';
import proCat from '../../img/under/Bucket.png';
import CAN from '../../img/under/CAN.png';
import CEMENT from '../../img/under/CEMENT.png';
import con from '../../img/under/con.png';
import CONSTT from '../../img/under/CONSTT.png';
import CYC from '../../img/under/CYCKE.png';
import DOM from '../../img/under/DOME.png';
import DRU from '../../img/under/DRU.png';
import DUSS from '../../img/under/DUST.png';
import GAMAL from '../../img/under/GAMLA.png';
import SILVER from '../../img/under/GOLDB.png';
import GOLDBUS from '../../img/under/GOLDBUC.png';
import HAN from '../../img/under/HANG.png';
import HUM from '../../img/under/HUMSAFER.png';
import KEP from '../../img/under/KEEPER.png';
import kallp from '../../img/under/KITCHEN ALL PRODUCT.png';
import LUN from '../../img/under/LUNDER.png';
import mug from '../../img/under/mug.png';
import MUL from '../../img/under/MULTI.png';
import pata from '../../img/under/PATA & STOOL ALL PRODUCT.png';
import print from '../../img/under/print.png';
import tub from '../../img/under/tub.png';

const categories = [
  'Bathroom Accessories',
  'Kitchen Products',
  'Gardening',
  'Pata and Stools',
  'Storage Organisers',
  'Cleaning Utilities',
  'Unbreakable Accessories',
  'Moulded Furniture Range',
];


const products = [
  { id: 1, name: 'Bucket', category: 'Bathroom Accessories', img:proCat,productName:'bucket'},
  { id: 2, name: 'MUGS', category: 'Bathroom Accessories', img: mug,productName:'mug'},
  { id: 3, name: 'Corner rack', category: 'Bathroom Accessories', img: con,productName:'Corner rack'},
  { id: 4, name: 'TUB', category: 'Bathroom Accessories', img: tub,productName:'tub'},
  { id: 4, name: 'Baby Bath tub', category: 'Bathroom Accessories', img: baby,productName:'Baby Bath tub'},
  { id: 4, name: 'Printed series', category: 'Bathroom Accessories', img: print,productName:'Printed series'},

    //  NEW
  { id: 5, name: 'KITCHEN ALL PRODUCT', category: 'Kitchen Products', img: kallp,productName:'KITCHEN ALL PRODUCT'},

  // new
  { id: 5, name: 'GARDENING ALL PRODUCT', category: 'Gardening', img: go,productName:'GARDENING ALL PRODUCT'},
   // new
  { id: 5, name: 'BATH STOOLS PATAS', category: 'Pata and Stools', img: pata,productName:'PATA & STOOL ALL PRODUCT'},
  //  { id: 5, name: 'PATA & STOOL', category: 'Pata and Stools', img: pata,productName:'PATA & STOOL ALL PRODUCT'},

   // new
  { id: 5, name: 'Cane Multi Food Container', category: 'Storage Organisers', img:CAN ,productName:'Cane Multi Food Container'},
  { id: 5, name: 'HANGER', category: 'Storage Organisers', img:HAN ,productName:'HANGER'},
  { id: 5, name: 'Multi-purpose Stand', category: 'Storage Organisers', img:MUL ,productName:'Multi-purpose Stand'},
  { id: 5, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img:KEP ,productName:'KEEPER WHITE TRANSPARENT BOXES'},
  { id: 5, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img:LUN ,productName:'LAUNDRY BASKET'},
  { id: 5, name: 'HUMSAFAR BASKET', category: 'Storage Organisers', img:HUM ,productName:'HUMSAFAR BASKET'},
  { id: 5, name: 'CYCLE BASKET', category: 'Storage Organisers', img:CYC ,productName:'CYCKE BASKET'},


   // new
  { id: 5, name: 'DRUMS', category: 'Cleaning Utilities', img: DRU,productName:'DRUMS'},
  { id: 5, name: 'DUSTPAN', category: 'Cleaning Utilities', img: DUSS,productName:'DUSTPAN'},
  { id: 5, name: 'DOMES & DUSTBIN', category: 'Cleaning Utilities', img: DOM,productName:'DOMES & DUSTBIN'},


  
  //  // new
  //  { id: 5, name: 'CLEANING ALL PRODUCT', category: 'Cleaning Utilities', img: CLEANING,productName:'CLEANING ALL PRODUCT'},




   //  // new
  { id: 5, name: 'CEMENT TAGARI', category: 'Unbreakable Accessories', img: CEMENT,productName:'CEMENT TAGARI'},
  { id: 5, name: 'CONSTRO TAGARI', category: 'Unbreakable Accessories', img: CONSTT,productName:'CONSTRO TAGARI'},
  { id: 5, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: GAMAL,productName:'GOLD GHAMELA'},
  { id: 5, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: SILVER,productName:'SILVER GHAMELA'},
  { id: 5, name: 'GOLD BUCKET', category: 'Unbreakable Accessories', img: GOLDBUS,productName:'GOLD BUCKET'},


];

function CategoryPage() {
  const { categoryName } = useParams();
  const [searchQuery, setSearchQuery] = useState('');

  const categoryProducts = products.filter(
    product =>
      product.category === categoryName &&
      product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="CategoryPage">
      <div className="upper">
        <h1>{categoryName}</h1>
      </div>
      <div className="main">
        <div className="filters">
          <div className="input_section">
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className="icons">
              <FontAwesomeIcon className="icon" color="#ffff" icon={faSearch} />
            </div>
          </div>
          <h4>PRODUCT CATEGORIES</h4>
          <select onChange={e => setSearchQuery(e.target.value)}>
            <option value="">All</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
        <div className="product-list">
          {categoryProducts.map(product => (
            <div key={product.name} className="product-item">
              <Link to={`/proo/${product.productName}`}>
                {product.img && <img src={product.img} alt={product.name} />}
                <h1>{product.name}</h1>
                <h2>{product.category}</h2>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryPage;
